import EcommerceApi from '../../agent/ecommerce';

export default class LocalCartUtils {
  static localStorageCartItems() {
    return JSON.parse(localStorage.getItem('cartItems')) || [];
  }

  static clearLocalStorageCartItems() {
    localStorage.removeItem('cartItems');
  }

  static async updateDbCartWithLocalCartItems() {
    return EcommerceApi.addToCart(this.localStorageCartItems());
  }

  static addToLocalStorageCartItems(productId, productType) {
    // For now, override with most recent item added
    localStorage.setItem('cartItems', JSON.stringify([{ id: productId, type: productType }]));
    /*
      // When multiple items are supported in checkout
      cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
      cartItems.push({id: productId, type: productType})
      localStorage.setItem('cartItems', JSON.stringify(cartItems));
     */
  }
}
